import { render } from "./VgrapherForm.vue?vue&type=template&id=1a5079e5&scoped=true"
import script from "./VgrapherForm.vue?vue&type=script&lang=js"
export * from "./VgrapherForm.vue?vue&type=script&lang=js"

import "./VgrapherForm.vue?vue&type=style&index=0&id=1a5079e5&lang=css&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5079e5"]])

export default __exports__